import React from 'react';
import '../../static/styles/apiguide.scss'
import '../../static/styles/dashboard.scss'

export default class LodgingAPIContent extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="col-sm-12">
                <div className="page-header" id="guides-section-08">
                    <h1 className="blog-title">숙박 API</h1>
                </div>
                {this.props.newDiv}
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/apis/LodgingAPIContent/LodgingAPIContent.jsx